module.exports = __webpack_public_path__ + "img/pinterest2.6003b4e4.svg";